import axios from "axios";
import queryString from "query-string";

const unauthorizedResponseInterceptor = publicBaseUrl =>
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response) {
        const {
          config: { url: requestUrl },
          status
        } = error.response;
        const isPublicUrl = requestUrl.startsWith(publicBaseUrl);
        const isUnauthorized = status === 401;
        const currentHref = window.location.href;
        const { url, query } = queryString.parseUrl(currentHref);

        if (!isPublicUrl && isUnauthorized) {
          window.location.replace(
            `${url}?${queryString.stringify(
              {
                ...query,
                auth_type: "personal"
              },
              { sort: false }
            )}`
          );
          return new Promise(() => {
            // Returning a new promise prevents any form from considering the ajax request complete
            // Keeps the page from jumping around with error before the browser completes navigation
            // according to the the window.location.replace
          });
        }
      }

      return Promise.reject(error);
    }
  );

export default unauthorizedResponseInterceptor;
